import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const STREAK_DOT_SIZE = 14;
export const STREAK_FLAME_SIZE = 36;

export const getStreakCardStyles = (theme: Theme) =>
  StyleSheet.create({
    card: {
      flex: 1,
      minWidth: 0,
      backgroundColor: theme.background.card,
      borderRadius: theme.borderRadius.xl,
      padding: 12,
      gap: 8,
      shadowColor: theme.shadow,
      shadowOpacity: 0.4,
      shadowRadius: 4,
      shadowOffset: { width: 0, height: 2 },
      elevation: 2,
    },
    cardPressed: {
      opacity: 0.85,
    },
    cardHover: {
      opacity: 0.92,
    },
    headerText: {
      gap: 1,
    },
    label: {
      fontSize: 11,
      fontWeight: '700',
      color: theme.gray[500],
      letterSpacing: 0.8,
      textTransform: 'uppercase',
    },
    subtitle: {
      fontSize: 10,
      color: theme.gray[500],
    },
    center: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      gap: 4,
      paddingVertical: 2,
    },
    flame: {
      width: STREAK_FLAME_SIZE,
      height: STREAK_FLAME_SIZE,
      alignItems: 'center',
      justifyContent: 'center',
    },
    countRow: {
      flexDirection: 'row',
      alignItems: 'baseline',
      gap: 4,
    },
    count: {
      fontSize: 34,
      fontWeight: '800',
      lineHeight: 36,
      letterSpacing: -0.7,
      color: theme.white,
      fontVariant: ['tabular-nums'],
    },
    countUnit: {
      fontSize: 12,
      fontWeight: '600',
      color: theme.gray[500],
    },
    dots: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      gap: 3,
    },
    dotColumn: {
      alignItems: 'center',
      gap: 3,
    },
    dot: {
      width: STREAK_DOT_SIZE,
      height: STREAK_DOT_SIZE,
      borderRadius: theme.borderRadius.full,
      borderWidth: 2,
    },
    dotClaimed: {
      backgroundColor: theme.success,
      borderColor: theme.success,
    },
    dotToday: {
      backgroundColor: 'transparent',
      borderColor: theme.primary,
    },
    dotLocked: {
      backgroundColor: 'transparent',
      borderColor: theme.gray[200],
    },
    dotLabel: {
      fontSize: 9,
      fontWeight: '700',
    },
    dotLabelClaimed: {
      color: theme.white,
    },
    dotLabelToday: {
      color: theme.primary,
    },
    dotLabelLocked: {
      color: theme.gray[400],
    },
    status: {
      fontSize: 10,
      fontWeight: '700',
      textAlign: 'center',
      fontVariant: ['tabular-nums'],
    },
    statusCollect: {
      color: theme.accent,
    },
    statusWait: {
      color: theme.gray[500],
    },
  });

export type StreakCardStyles = ReturnType<typeof getStreakCardStyles>;
